<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrderDetails/purchaseOrderDetail"
        @select="selectHandle"
        @select-all="selectHandle">
      <div slot="toolbar">
        <el-button v-if="createAuth" type="primary" @click="createDeliverySlip">创建送货单</el-button>
        <el-button type="primary" :loading="exportLoading" @click="openExport">导出</el-button>
        <el-button v-if="cableAuth" type="success" :loading="exportLoading" @click="exportExcel(2)">
          导出线缆参数
        </el-button>
        <el-button type="primary" :loading="printLoading" @click="printInvoice()">打印采购单</el-button>
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="printInvoiceByXl()">
          打印采购单(线缆)
        </el-button>
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="gotoCablePrint()">线缆流转单</el-button>
        <el-button v-if="cableAuth" type="success" :loading="printLoading" @click="gotoCablePrintDongLi()">
          动力线缆流转单
        </el-button>
        <el-button type="primary" @click="billBarcode">按单条码</el-button>
        <el-button type="primary" @click="materialBarcode">物料条码</el-button>
        <el-button type="success" @click="cableBarcode">线缆条码</el-button>
        <el-button type="success" @click="cablePackBarcode">线缆包装条码</el-button>
        <el-button type="primary" @click="procureDateSubmit">按采购交期批量提交</el-button>
        <el-button type="primary" @click="customDateSubmit">自定义交期批量提交</el-button>
        <el-checkbox
            v-model="checked"
            label="隐藏金额"
            style="margin-left: 5px;border: 1px solid #e6e6e6;padding: 3px 15px 3px 7px;"/>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单号">
            <el-input
                v-model.trim="filter.purchaseOrderNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                style="width: 150px"
                clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input
                v-model.trim="filter.pcorderNo"
                type="textarea"
                :autosize="{ minRows:1, maxRows:6 }"
                style="width: 150px"
                clearable/>
          </vm-search>
          <vm-search label="客户合同号">
            <el-input v-model.trim="filter.clientContractNO" style="width: 190px" clearable/>
          </vm-search>
          <vm-search label="供应商">
            <el-input v-model.trim="filter.supplierName" style="width: 190px" clearable/>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.partNo" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="库位">
            <el-input v-model.trim="filter.location" style="width: 150px" clearable/>
          </vm-search>
          <vm-search label="接收状态">
            <el-select v-model.trim="filter.receiveStatus" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="供应商未确认" :value="0"/>
              <el-option label="采购退回" :value="1"/>
              <el-option label="采购未确认" :value="2"/>
              <el-option label="已确认" :value="5"/>
              <el-option label="部分创建" :value="10"/>
              <el-option label="已创建" :value="20"/>
            </el-select>
          </vm-search>
          <vm-search label="订单类型">
            <el-select v-model.trim="filter.production" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="生产" :value="0"/>
              <el-option label="非生产" :value="1"/>
            </el-select>
          </vm-search>
          <vm-search label="发货单创建状态">
            <el-select v-model.trim="filter.isFinished" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="已完成" :value="0"/>
              <el-option label="未完成" :value="1"/>
            </el-select>
          </vm-search>
          <vm-search label="入库状态">
            <el-select v-model.trim="filter.isStock" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="已完成" :value="1"/>
              <el-option label="未完成" :value="0"/>
            </el-select>
          </vm-search>
          <vm-search label="直发标识">
            <el-select v-model.trim="filter.straightMark" placeholder="请选择">
              <el-option label="全部" :value="'-1'"/>
              <el-option label="按单直发工地" :value="'Z001'"/>
              <el-option label="备库直发工地" :value="'Z002'"/>
              <el-option label="发新时达" :value="'1000'"/>
            </el-select>
          </vm-search>
          <vm-search label="外发标识">
            <el-select v-model.trim="filter.zsign" placeholder="请选择">
              <el-option label="全部" :value="''"/>
              <el-option label="外发" :value="'外发'"/>
              <el-option label="排产" :value="'排产'"/>
            </el-select>
          </vm-search>
        </div>
        <vm-search label="交货日期">
          <div class="block">
            <el-date-picker
                v-model="filter.requireDeliveryDateBegin"
                placement="bottom-start"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 165px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.requireDeliveryDateEnd"
                placement="bottom-start"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="回复交期">
          <div class="block">
            <el-date-picker
                v-model="filter.responseDeliveryTimeBegin"
                placement="bottom-start"
                value-format="yyyy-MM-dd 00:00:00"
                type="date"
                style="width: 165px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.responseDeliveryTimeEnd"
                placement="bottom-start"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="提前交货" style="width: 80px">
          <el-checkbox v-model="filter.ahead" style="margin-top: 5px;"/>
        </vm-search>
        <vm-search label="逾期交货" style="width: 80px">
          <el-checkbox v-model="filter.overdue" style="margin-top: 5px;"/>
        </vm-search>
        <vm-search label="不显示关联公司" style="width: 80px">
          <el-checkbox v-model="filter.relatedCompany" style="margin-top: 5px;"/>
        </vm-search>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="status" align="center" width="60px" label="状态">
        <template slot-scope="scope">
          {{constant.purchaseOrderStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="priority" align="center" width="60px" label="级别">
        <template slot-scope="scope">
          {{formatter(scope.row)}}
          <!-- <span v-if="scope.row.priority === -1">全部</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="receiveStatus" align="center" width="100px" label="接收状态">
        <template slot-scope="scope">
          {{getTitle(scope.row.receiveStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="addDate" align="center" label="下单日期" width="120">
        <template slot-scope="scope">
          <span>{{scope.row.addDate.slice(0, 10)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sapApproveTime" align="center" label="审核时间" width="150"/>
      <el-table-column
          prop="supplierName"
          align="left"
          label="供应商"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column
          prop="supplierNo"
          align="center"
          label="供应商编号"
          min-width="90"
          show-overflow-tooltip/>
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          width="90">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="gotoBuyOrder(scope.row)">
            {{scope.row.evaluate}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" align="center" label="销售订单号" width="90">
        <template slot-scope="scope">
          <div style="color: #2D8CF0;cursor: pointer" @click="goto(scope.row)">
            {{scope.row.orderNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pCorderNo" align="center" label="出厂编号" width="100">
        <template slot-scope="scope">
          <div style="color: #2D8CF0;cursor: pointer" @click="goto(scope.row)">{{scope.row.pCorderNo}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="clientContractNO"
          align="center"
          label="客户合同号"
          width="100"
          show-overflow-tooltip/>
      <el-table-column prop="rowNum" align="center" label="行号" width="70"/>
      <el-table-column
          prop="partNo"
          align="center"
          label="物料编号"
          width="100"
          show-overflow-tooltip/>
      <el-table-column
          prop="partNameSpec"
          align="left"
          label="物料描述"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column prop="location" align="center" label="库位" width="70"/>
      <el-table-column prop="requireDeliveryDate" align="center" label="交期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.requireDeliveryDate ? scope.row.requireDeliveryDate.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="responseDeliveryTime" align="center" label="回复交期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="buyUserName" align="center" label="采购组" width="80"/>
      <el-table-column prop="qty" align="center" label="采购订单数量" width="100"/>
      <el-table-column prop="sumReceiveQty" align="center" label="送货单数量" width="90"/>
      <el-table-column prop="hasInStorageQty" align="center" label="已入库数量" width="90"/>
      <el-table-column prop="productionBeginDate" align="center" label="开工日期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.productionBeginDate ? scope.row.productionBeginDate.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invoiceDeliveryDate" align="center" label="发货日期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.invoiceDeliveryDate ? scope.row.invoiceDeliveryDate.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="straightMark" align="center" label="直发标识" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.straightMark === '1000'">发新时达</span>
          <span v-if="scope.row.straightMark === 'Z001'">按单直发工地</span>
          <span v-if="scope.row.straightMark === 'Z002'">备库直发工地</span>
        </template>
      </el-table-column>
      <el-table-column prop="zsign" align="center" label="标识" width="60"/>
      <el-table-column prop="unitPrice" align="center" label="单价" width="70">
        <template slot-scope="scope">
          <span>{{scope.row.unitPrice ? scope.row.unitPrice.toFixed(2) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" align="center" label="总价" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.price ? scope.row.price.toFixed(2) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unit" align="center" label="单位" width="55"/>
      <el-table-column
          prop="remark"
          align="left"
          label="备注"
          show-overflow-tooltip
          width="200"/>
      <!--      <el-table-column-->
      <!--          prop="remark"-->
      <!--          align="left"-->
      <!--          label="操作"-->
      <!--          show-overflow-tooltip-->
      <!--          fixed="right"-->
      <!--          width="100">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button type="primary" @click="post(scope.row)">过账</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </vm-table>
    <create-delivery-bill-dialog ref="createDeliveryBillDialog" @save-success="getList(1)"/>
    <preview ref="preview" @save-success="getList(-1)"/>
    <material-barcode-print-edit ref="materialBarcode"/>
    <custom-date-submit ref="customDate" @save-success="getList(-1)"/>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="打印销单" prop="salesOrderPrint">
          <el-select v-model="filter.salesOrderPrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
        <el-form-item label="打印节点附件" prop="isNodeId">
          <el-select v-model="filter.isNodeId" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="printLoadingByXl" type="primary" @click="submitHandle(true)">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="noteDialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="打印备注" prop="notePrint">
          <el-select v-model="filter.notePrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="noteDialogVisible = false">取消</el-button>
        <el-button :loading="printLoading" type="primary" @click="submitHandle(filter.notePrint)">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="exportDialogVisble"
        :close-on-click-modal="false"
        title="导出选项">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-radio v-model="filter.exportChoose" label="勾选内容">勾选内容</el-radio>
        <el-radio v-model="filter.exportChoose" label="搜索条件">搜索条件</el-radio>
      </el-form>
      <span slot="footer">
        <el-button @click="exportDialogVisble = false">取消</el-button>
        <el-button :loading="printLoading" type="primary" @click="exportExcel(1)">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import CreateDeliveryBillDialog from "./CreateDeliveryBillDialog.vue";
  import Preview from "./Preview";
  import MaterialBarcodePrintEdit from "./MaterialBarcodePrintEdit.vue";
  import CustomDateSubmit from "./CustomDateSubmit";
  import CablePrintProperty from "@/views/purchase/purchaseDeliveryNew/CablePrintProperty";

  export default {
    name: "PurchaseDeliveryNewList",
    components: {
      VmTable,
      VmSearch,
      CreateDeliveryBillDialog,
      Preview,
      MaterialBarcodePrintEdit,
      CustomDateSubmit,
    },
    data() {
      return {
        constant,
        noteDialogVisible: false,
        exportDialogVisble: false,
        createAuth: this.$auth(239),
        exportLoading: false,
        printLoading: false,
        checked: false,
        printLoadingByXl: false,
        dialogVisible: false,
        cableAuth: this.$auth(240),
        filter: {
          purchaseOrderNo: "",
          pcorderNo: "",
          supplierName: "",
          partNo: "",
          buyUserName: "",
          location: "",
          receiveStatus: -1,
          production: -1,
          isFinished: 1,
          straightMark: "-1",
          requireDeliveryDateBegin: "",
          requireDeliveryDateEnd: "",
          responseDeliveryTimeBegin: "",
          responseDeliveryTimeEnd: "",
          ahead: false,
          overdue: false,
          relatedCompany: true,
          purchaseList: [],
          showPrice: false,
          salesOrderPrint: true,
          isNodeId: true,
          nodeId: "",
          notePrint: true,
          zsign: "",
          exportChoose: "搜索条件",
          idList: "",
          isStock:0,
        },
        selection: [], // 选中的供应商
        ruleValidate: {
          salesOrderPrint: {required: true, message: "打印销单/流水单不能为空", trigger: "blur"},
          isNodeId: {required: true, message: "打印节点附件不能为空", trigger: "blur"},
          notePrint: {required: true, message: "打印备注不能为空", trigger: "blur"},
        },
        straightMarkList: [
          {label: "按单直发工地", value: "Z001"},
          {label: "备库直发工地", value: "Z002"},
          {label: "发新时达", value: "1000"},
        ],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      // 查询
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 供应商选中
      selectHandle(selection) {
        this.selection = selection;
        this.buyOrderNoList = [];
        for (let item of this.selection) {
          this.buyOrderNoList.push(item.evaluate);
        }
      },
      // 创建送货单
      createDeliverySlip() {
        if (!this.selection.length) {
          this.$confirm("请选择采购订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let isNext = true;
          for (let item of this.selection) {
            if (item.receiveStatus !== 5) {
              isNext = false;
              break;
            }
          }
          if (!isNext) {
            return this.$confirm("接受状态为已确认才可创建送货单", "错误", {
              type: "error",
              showCancelButton: false,
            });
          } else {
            const straightMark = this.selection.every((item) => item.straightMark === this.selection[0].straightMark);
            const result = this.selection.every((item) => item.supplierNo === this.selection[0].supplierNo);
            const location = this.selection.every((item) => item.location === this.selection[0].location);
            if (result && straightMark && location) {
              this.$refs.createDeliveryBillDialog.open(0, this.selection);
            } else if (!result) {
              this.$confirm("供应商不一致,请重新选择", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else if (!straightMark) {
              this.$confirm("直发标识不一致,请重新选择", "错误", {
                type: "error",
                showCancelButton: false,
              });
            } else if (!location) {
              this.$confirm("仓位不一致,请重新选择", "错误", {
                type: "error",
                showCancelButton: false,
              });
            }
          }

        }
      },

      post(row) {
        this.$http.post("basic", "sAPPurchaseOrderDetails/post", row);
      },

      openExport() {
        this.exportDialogVisble = true;
      },

      // 导出
      exportExcel(dataType) {
        console.log(dataType,this.filter);
        let url = "";
        if (dataType === 1) {
          if (this.filter.exportChoose === "勾选内容") {
            if (this.selection.length === 0) {
              this.$message.error("未勾选任何内容");
            } else {
              this.selection.forEach(item => this.filter.idList=this.filter.idList+item.pkid+",");
            }
          }
          url = "sAPPurchaseOrderDetails/purchaseOrderDetailExport";
        } else if (dataType === 2) {
          url = "sAPPurchaseOrderDetails/exportCableProperty";
        }
        console.log(url);
        this.exportLoading = true;
        this.$http
          .exportFile("basic", url, this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      gotoBuyOrder(row) {
        console.log(row);
        this.$refs.preview.open(row);
        const element = event.target;
        element.style.textDecoration = "underline";
      },
      goto(row) {
        console.log(row);
        this.$router.push({
          path: "/SalesOrderPreviewBySupplierNew",
          query: {
            billType: 1,
            billId: row.techParamBillID,
            orderNo: row.orderNo,
            $tabName: row.orderNo,
          },
        });
        const element = event.target;
        element.style.textDecoration = "underline";
      },

      gotoCablePrint() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        this.purchaseList = [];
        for (let item of this.selection) {
          this.purchaseList.push(item.evaluate);
        }
        this.$router.push({
          path: "/CablePrintProperty",
          query: {
            purchaseList: this.purchaseList,
          },
        });
      },
      gotoCablePrintDongLi() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        this.purchaseList = [];
        for (let item of this.selection) {
          this.purchaseList.push(item.evaluate);
        }
        this.$router.push({
          path: "/CablePrintPropertyDongLi",
          query: {
            purchaseList: this.purchaseList,
          },
        });
      },


      // 打印采购单
      printInvoice() {
        if (this.buyOrderNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的采购单");
          return;
        }
        this.noteDialogVisible = true;
        this.filter.salesOrderPrint = false;
        this.filter.nodeId = "";
      },
      formatter(row) {
        let txt = row.priority > 0 ? "优先" : "正常";
        if (row.integrationTesting) {
          txt += "/联调";
        }
        return txt;
      },
      getTitle(val) {
        switch (val) {
          case -1:
            return "全部";
          case 0:
            return "供应商未确认";
          case 1:
            return "采购退回";
          case 2:
            return "采购未确认";
          case 5:
            return "已确认";
          case 10:
            return "部分创建发货单";
          case 20:
            return "全部创建发货单";
        }
      },
      billBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let arrs = [];
        this.selection.forEach((item) => {
          if (!arrs.includes(item.mastPKID)) {
            arrs.push(item.mastPKID);
          }
        });


        let ids = arrs.join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintOne.aspx?SystemNo=" + ids);
      },
      materialBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        if (this.selection.length > 1) {
          this.$message.error("至多选择一行记录");
          return;
        }
        this.$refs.materialBarcode.open(this.selection);
      },
      cableBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let ids = this.selection.map(item => item.mastPKID).join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintOne_XL.aspx?SystemNo=" + ids);
      },
      cablePackBarcode() {
        if (this.selection.length === 0) {
          this.$message.error("请选择至少一行记录");
          return;
        }
        let ids = this.selection.map(item => item.mastPKID).join(",");
        window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintCable.aspx?SystemNo=" + ids);
      },
      procureDateSubmit() {
        if (this.selection.length === 0) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let orderVoList = [];
        this.selection.forEach(item => {
          let model = {
            pkid: item.mastPKID,
          };
          orderVoList.push(model);
        });
        let param = {
          orderVoList: orderVoList,
          responseTime: null,
        };
        this.$http.post("basic", "sAPPurchaseOrders/responseDeliveryTimeList", param).then((res) => {
          this.getList(-1);
          this.$message.success("提交成功");
        });
      },
      customDateSubmit() {
        if (this.selection.length === 0) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.$refs.customDate.open(this.selection);
      },

      printInvoiceByXl() {
        if (this.buyOrderNoList.length === 0) {
          this.$message.error("请至少选择一条需要打印的采购单");
          return;
        }
        this.dialogVisible = true;
      },
      submitHandle(notePrint) {
        this.filter.notePrint = notePrint;
        this.filter.purchaseList = this.buyOrderNoList;
        this.filter.showPrice = !this.checked;
        if (this.filter.isNodeId) {
          this.filter.nodeId = "techForeCheck";
        } else {
          this.filter.nodeId = "0";
        }
        this.printLoadingByXl = true;
        this.$http
          .postForFile("basic", "sAPPurchaseOrders/purchaseList/", this.filter)
          .then((res) => {
            console.log(res);
            let blob = new Blob([res.data], {type: "application/pdf"});
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
            this.printLoadingByXl = false;
            this.dialogVisible = false;
            this.noteDialogVisible = false;
            this.printLoading = false;
            this.filter.purchaseList = [];
          }).catch(() => {
            this.printLoadingByXl = false;
            this.dialogVisible = false;
            this.noteDialogVisible = false;
            this.printLoading = false;
          });
      },
    },
  };
</script>

<style>
.el-table-column--selection .cell {
  padding-right: 10px;
}
</style>
